import React from "react";
import Grid_Chart from "src/components/common/gridWrapper/Grid_Chart";
import { PivotRowConfig, DEFAULT_LEADING_COLUMNS } from "src/utils/grid/gridPivotUtils";
import { MONTH_LABELS, buildMonthlySeries } from "src/utils/chart/chartUtils";
import { PRD5030_R01ResultDto } from "./Dto_PRD5030_R01";

// Table 컴포넌트가 받는 props 타입
interface Props {
	data: PRD5030_R01ResultDto[]; // 월별(1~12월) 결과 리스트
}

// 월별 시간가동율 피벗 그리드의 구분별 행 설정
const PIVOT_ROWS: PivotRowConfig<PRD5030_R01ResultDto>[] = [
	{ field: "workMin", label: "작업시간" },
	{ field: "downMin", label: "비가동시간" },
	{ field: "operatingRate", label: "시간가동율" },
];

// 월별 시간가동율 피벗 그리드 컴포넌트 (grid_chart 공통 컴포넌트 사용)
export const Table_PRD5030_R01: React.FC<Props> = ({ data }) => {
	return (
		<Grid_Chart<PRD5030_R01ResultDto>
			data={data}
			rowData={PIVOT_ROWS}
			leadingColumnDefs={DEFAULT_LEADING_COLUMNS}
			periodLabels={MONTH_LABELS}
			seriesBuilder={buildMonthlySeries}
			columnStateKey="PRD5030_R01-chart-grid-column-state"
		/>
	);
};
